//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

export interface IContentItemMetadata {
  contentType?: string;
}

export interface IContentItem {
  metadata: IContentItemMetadata;
  videoId?: string;
}

export class ImageMetadataService {
  private static readonly gifContentTypeRegex = /^image\/gif/i;

  public isGif(item: IContentItem): boolean {
    const contentType = item.metadata.contentType;
    const hasVideoId = !!item.videoId;  // Ignore videos with GIF thumbnails
    if (!contentType || hasVideoId) {
      return false;
    }

    return ImageMetadataService.gifContentTypeRegex.test(contentType);
  }
}

angular.module('curalate').service('ImageMetadataService', [
  ImageMetadataService,
]);
